import moment from 'moment'

const getLocalTime = (time) => {
  if (time) {
    const localTime = moment(time).local().format('HH:mm')

    return localTime
  }

  return ''
}

const getLocalDateTime = (time) => {
  if (time) {
    const localTime = moment(time).local().format('HH:mm on DD/MM/YY')

    return localTime
  }

  return ''
}

export { getLocalTime, getLocalDateTime }



// WEBPACK FOOTER //
// ./src/utils/timer.js